import React, { useCallback } from 'react';
import { AnimatedContainer } from '../AnimatedContainer/AnimatedContainer';
import { SupportedAlohaHeaderPhotoLayoutSchema } from '@apps/guest/packages/layout-engine/layouts/hooks/useWebsiteHeaderSettings';
import { PhotoSlider } from '@apps/guest/packages/layout-engine/widgets/Custom/components';
import { Photo } from '../Photo/Photo';

interface HeaderPhotoProps {
  headerPhoto?: SupportedAlohaHeaderPhotoLayoutSchema;
}

export const HeaderPhoto = ({ headerPhoto }: HeaderPhotoProps) => {
  const getHeaderPhotoComponent = useCallback(() => {
    if (!headerPhoto) {
      return null;
    }

    switch (headerPhoto.presentationLayout) {
      case 'center':
        return (
          <AnimatedContainer>
            <Photo {...headerPhoto?.photos?.[0]} />
          </AnimatedContainer>
        );
      case 'photoSlider':
        return (
          <AnimatedContainer>
            <PhotoSlider photos={headerPhoto?.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || []} photoHeight="100vh" />
          </AnimatedContainer>
        );
      default:
        return null;
    }
  }, [headerPhoto]);

  return getHeaderPhotoComponent();
};
